module.exports = __webpack_public_path__ + "static/support-9836c3a5969e321988e0f7eac899704b.png";